import { FormControl, InputLabel, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import Select from '@material-ui/core/Select';
import {
  InputAdornment, ListSubheader,
  TextField, Tooltip, Box
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import MenuItem from '@material-ui/core/MenuItem';



const YearDropdown = ({ onSelect }) => {
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [searchText, setSearchText] = useState("");


  const years = Array.from({ length: 10 }, (_, index) => currentYear - index);
  

  const handleYearChange = (event) => {
    const year = parseInt(event.target.value, 10);
    setSelectedYear(year);
    onSelect(year);
  };

  return (
    // <select style={{"height":"34px","width":"80px"}}value={selectedYear} onChange={handleYearChange}>
    //   {years.map((year) => (
    //     <option key={year} value={year}>
    //       {year}
    //     </option>
    //   ))}
    // </select>
  
        <Select
        className='billingyear'
          value={selectedYear || null}
          onChange={handleYearChange}
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left"
            },
            autoFocus: false,
            getContentAnchorEl: null
          }}
          onClose={() => setSearchText("")}>
          <ListSubheader style={{ position: 'inherit' }}>
            <TextField
              size="small"
              // Autofocus on textfield
              variant='outlined'
              autoFocus
              placeholder="Type to search..."
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key !== "Escape") {
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
          {
          
          years && years.length > 0 &&  years.map((each,index)=>{
          return  <MenuItem value={each || ''}><Typography variant="inherit" > 
          <pre style={{ fontFamily: 'inherit', margin: '0px', fontWeight: '600' }}>
           {each === "emptyspace" ? "" : each}
         </pre></Typography> </MenuItem> // {//index }
          })
          }
        </Select>
     
  );
};

export default YearDropdown;